import * as React from 'react';
import { isEqual, parseISO } from 'date-fns';

import { RouteType, Day, getDaysFromMonth, MonthsMap, Prices } from '@features/price-graph';
import { Money } from '../../../../../../Money/types';

interface Props {
	initialDate: Date;
	routeType: RouteType;
	backDate: Date;
	outDate: Date;
	monthsPricesMap: MonthsMap;
	prices: Prices;
	onSelect?: (date: Date, isBackDate?: boolean) => void;
	focusedDate?: string;
	isMobileMode?: boolean;
}

const defaultMoney = { amount: 0, currency: null } as Money;

const Month: React.FC<Props> = ({
	initialDate,
	monthsPricesMap,
	prices,
	outDate,
	backDate,
	routeType,
	focusedDate,
	isMobileMode,
	onSelect
}) => {
	const isoInitialDate = initialDate.toISOString();

	const monthData = monthsPricesMap[isoInitialDate];
	const minPrice = monthData?.minPrice ?? defaultMoney;
	const maxPrice = monthData?.maxPrice ?? defaultMoney;

	return (
		<>
			{getDaysFromMonth(initialDate).map((date: Date, index: number) => {
				const dateISO = date.toISOString();

				const price = (prices.hasOwnProperty(dateISO) && prices[dateISO]?.price) ?? {
					amount: 0,
					currency: maxPrice.currency
				};

				return (
					<Day
						key={index}
						minPrice={minPrice}
						maxPrice={maxPrice}
						price={price}
						date={date}
						isOutDate={outDate && dateISO === outDate.toISOString()}
						isBackDate={backDate && dateISO === backDate.toISOString()}
						routeType={routeType}
						onSelect={onSelect}
						isFocused={focusedDate && isEqual(parseISO(focusedDate), date)}
						isMobileMode={isMobileMode}
					/>
				);
			})}
		</>
	);
};

export default Month;
